export const ARTICLE_IMAGE_SIZE = 230;
export const ARTICLE_IMAGE_SM_SIZE = 145;

export const HEADER_IMAGE_DIMENSIONS = { width: 660, height: 420 };
export const HEADER_IMAGE_SM_DIMENSIONS = { width: 375, height: 210 };

export const ARTICLE_MODAL_IMAGE_DIMENSIONS = { width: 260, height: 260 };
export const ARTICLE_SWIPE_MODAL_IMAGE_DIMENSIONS = { width: 300, height: 300 };
export const ARTICLE_MODAL_THUMBNAIL_DIMENSIONS = { width: 80, height: 80 };
export const ITEMS_LEFT_WARNING_COUNT = 10;
